module.exports = __webpack_public_path__ + "img/icon_kqtj.f87747e1.png";